module.exports = __webpack_public_path__ + "img/brume-hero_lg.3d2c15b.webp";